import { apiClient } from "@copro/api";

export async function syncProviderTags(providerId: string, tagIds: string[]) {
  const { error: deleteError } = await apiClient
    .from('provider_tag_assignments')
    .delete()
    .eq('provider_id', providerId);

  if (deleteError) {
    throw deleteError;
  }

  if (tagIds.length > 0) {
    const rows = tagIds.map((tag_id) => ({
      provider_id: providerId,
      tag_id,
    }));
    const { error: insertError } = await apiClient
      .from('provider_tag_assignments')
      .insert(rows);

    if (insertError) {
      throw insertError;
    }
  }
}

